export default __webpack_public_path__ + "static/5_30-66b9d98478f8a19fa1ab40746d24ec59.png";